angular.module('app')
  .directive('mediathequeLieuditInput', LieuditInputDirective);

function LieuditInputDirective() {
  return {
    restrict: 'E',
    scope: {
      name: '@mediathequeName',
      id: '@mediathequeId',
      form: '@mediathequeForm',
      disabled: '&mediathequeDisabled',
      model: '=ngModel',
      onChange: '&mediathequeOnChange',
      initialValue: '&mediathequeInitialValue',
      applyFocus: '&mediathequeApplyFocus'
    },
    replace: true,
    controller: LieuditInputController,
    controllerAs: 'inputCtrl',
    templateUrl: 'common/lieudit-input.html'
  };
}

/*@ngInject*/
function LieuditInputController($scope) {
  var inputCtrl = this;

  inputCtrl.onChange = $scope.onChange;

  init();

  // TODO: Ajouter un watcher sur $scope.model (couplé à un $timeout pour s'assurer que le scope est bien à jour)
  // si le model initial est modifié par le composant parent

  function init() {
    if ($scope.model) {
      inputCtrl.lieudit = $scope.model;
      return;
    }

    inputCtrl.lieudit = $scope.model = $scope.initialValue() || { nom: { libelle: ""}, precision: { libelle: ""} };
  }
}
